export const subtractArray = (arr1, arr2) => 
// Inspired by: https://stackoverflow.com/questions/19957348/remove-all-elements-contained-in-another-array
arr1.filter((i) => !arr2.includes(i));
export const getLastItemInArray = (arr) => arr[arr.length - 1];
export const reverseArray = (array) => {
    const clone = [...array];
    // Problem with reverse() is that it mutates original array
    return clone.reverse();
};
/**
 * Returns a valid index after considering the current index and the given array.
 * E.g. current index outside the bounds of an array will return the index of the last element.
 */
export const getValidIndexForArrayAndCurrentIndex = (array, currentIndex) => {
    if (array.length - 1 < currentIndex) {
        return array.length - 1;
    }
    if (currentIndex < 0) {
        return 0;
    }
    return currentIndex;
};
